{
  "version": 1,
  "asset_id": "6b067f6c-df40-432d-b409-cdeefd22f45c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6b067f6c-df40-432d-b409-cdeefd22f45c/lap-band-removed-1600.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6b067f6c-df40-432d-b409-cdeefd22f45c/lap-band-removed-1600.jpg",
  "original_filename": "lap-band-removed-1600.jpg",
  "size": 228236,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T00:12:16Z"
}
